/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagePaymentDTO } from '../models/PagePaymentDTO';
import type { PaymentDTO } from '../models/PaymentDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomPaymentResourceService {
    /**
     * @returns PaymentDTO OK
     * @throws ApiError
     */
    public static createPayment1({
        signallerId,
    }: {
        /**
         * The signaller who has to be paid
         */
        signallerId: number,
    }): CancelablePromise<PaymentDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/custom/payment/addPayment/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
        });
    }
    /**
     * Get the payment dto requested
     * Retrieves the payment dto requested
     * @returns PaymentDTO OK
     * @throws ApiError
     */
    public static getPayment1({
        paymentId,
    }: {
        /**
         * The id of the payment requested
         */
        paymentId: number,
    }): CancelablePromise<PaymentDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/payment/{paymentId}',
            path: {
                'paymentId': paymentId,
            },
        });
    }
    /**
     * Get list of all payments associated to the same signaller
     * Retrieves a paginated list of all payments associated to the same signaller
     * @returns PagePaymentDTO OK
     * @throws ApiError
     */
    public static getAllSignallerPayments({
        signallerId,
        page,
        size = 10,
        sortBy = 'paymentDate',
        sortDir = 'asc',
    }: {
        /**
         * The signaller ID to filter by
         */
        signallerId: number,
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PagePaymentDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/payment/signaller-payments/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deletePayment1({
        id,
    }: {
        /**
         * The id of the payment to delete
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/custom/payment/deletePayment/{id}',
            path: {
                'id': id,
            },
        });
    }
}
